<template>
    <div class="checkbox-group">
        <filter-block-checkbox
        v-for="option in options"
        :checked="value.includes(option.id)"
        @update:checked="check(option.id, option.name, option.slug, $event)"
        @reset:all="check(0, '', '', $event)"
        :fieldId="option.name"
        :label="option.name"
        :slug="option.slug"
        :key="option"
        ></filter-block-checkbox>
    </div>
</template>
<script>
    import FilterBlockCheckbox from "./FilterBlockCheckbox";
    export default {
        emits: ["update:value" ,"reset:all"],
        props: {
            value: {
                type: Array,
                required: true,
            },
            options: {
                type: Array,
                required: true,
                validator: (value) => {
                    const hasNameKey = value.every((option) =>
                        Object.keys(option).includes("name")
                    );
                    const hasIdKey = value.every((option) =>
                        Object.keys(option).includes("id")
                    );
                    return hasNameKey && hasIdKey;
                },
            },
        },
        setup(props, context) {
            const check = (optionId, optionName, optionSlug, checked) => {
                let updatedValue = [...props.value];

                let filterObject = {
                    name: optionName,
                    slug: optionSlug,
                    id: optionId
                };

                if (checked) {
                    updatedValue.push(filterObject);
                } else {
                    updatedValue.forEach(function(arrValue, index) {
                        if (arrValue.id === optionId) {
                            updatedValue.splice(index, 1);
                        }
                    })
                }

                // Reset all filters by emptying return array
                if (checked === false && optionId === 0) {
                    updatedValue = [];
                }

                context.emit("update:value", updatedValue);
            };

            return {
                check,
            };

        },
        components: {
            "filter-block-checkbox": FilterBlockCheckbox,
        }
    };
</script>